/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AbstractResourceService, JsonApiResource} from '@irian-ro/abstract-resource';
import {EnvironmentService} from "@irian-ro/util-environment";
import {
  ShipTransactionTermsAndCondAgreementDTO, ShipTransactionTermsAndCondRejectDTO
} from '@well/domain';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShipTransactionTermsAndConditionsAgreementResourceService extends AbstractResourceService<any, ShipTransactionTermsAndCondAgreementDTO, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('shipmentTransactionTermsAndCondAgreementUrl'),
      undefined,
      ShipTransactionTermsAndCondAgreementDTO
    );
  }

  getShipTransTermsAndCondForSPOfferReq(serviceProvOfferReqUuid: string): Observable<JsonApiResource<ShipTransactionTermsAndCondAgreementDTO, any>> {
    return <Observable<JsonApiResource<ShipTransactionTermsAndCondAgreementDTO, any>> >this.httpClient?.get(`${this.url}/sp-offer-req/${serviceProvOfferReqUuid}`);
  }

  getShipTransTermsAndCondForOffer(offerUuid: string): Observable<JsonApiResource<ShipTransactionTermsAndCondAgreementDTO, any>> {
    return <Observable<JsonApiResource<ShipTransactionTermsAndCondAgreementDTO, any>>>this.httpClient?.get(`${this.url}/offer/${offerUuid}`);
  }

  getShipTransTermsAndCondForShipmentGroup(shipmentGroupUuid: string): Observable<JsonApiResource<ShipTransactionTermsAndCondAgreementDTO, any>> {
    return <Observable<JsonApiResource<ShipTransactionTermsAndCondAgreementDTO, any>>> this.httpClient?.get(`${this.url}/shipment-group/${shipmentGroupUuid}`);
  }

  getShipTransTermsAndCondForSPOrder(spOrderUuid: string): Observable<JsonApiResource<ShipTransactionTermsAndCondAgreementDTO, any>> {
    return <Observable<JsonApiResource<ShipTransactionTermsAndCondAgreementDTO, any>>>this.httpClient?.get(`${this.url}/service-provider-order/${spOrderUuid}`);
  }

  markAsSeenShipTransactionTermsAndConditionsAgreementForUuid(uuid: string): Observable<boolean> {
    return <Observable<boolean>>this.httpClient?.post(`${this.url}/seen/${uuid}`, null);
  }

  acceptShipTransTermsAndCondAgreement(uuid: string): Observable<boolean> {
    return <Observable<boolean>>this.httpClient?.post(`${this.url}/${uuid}/accept`, null);
  }

  rejectShipTransTermsAndCondAgreementForSPOfferReq(rejectDTO: ShipTransactionTermsAndCondRejectDTO): Observable<boolean> {
    return <Observable<boolean> >this.httpClient?.post(`${this.url}/sp-offer-req/reject/`, rejectDTO);
  }

  rejectShipTransTermsAndCondAgreementForOffer(rejectDTO: ShipTransactionTermsAndCondRejectDTO): Observable<boolean> {
    return <Observable<boolean> >this.httpClient?.post(`${this.url}/offer/reject/`, rejectDTO);
  }
}
